// extracted by mini-css-extract-plugin
module.exports = {"container":"Kl","columns":"Ll","designs":"Ml","carousel":"Nl","designContainer":"Ol","selected":"Pl","info":"Ql","code":"Rl","amount":"Sl","egcInCart":"Tl"};